import QuestionTemplate from "./QuestionTemplate";

export class Operation {
  constructor({
    firstOperator = null,
    secondOperator = null,
    operator = null,
    resultField = null,
    label = "",
    id = Number.NaN,
  } = {}) {
    this.firstOperator = new QuestionTemplate(firstOperator);
    this.secondOperator = new QuestionTemplate(secondOperator);
    this.resultField = new QuestionTemplate(resultField);
    this.operator = operator;
    this.label = label;
    this.id = id;
  }
}
